/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface SecureControllerHasSecondaryPassword$Params {
  centerId: string;
}

export function secureControllerHasSecondaryPassword(http: HttpClient, rootUrl: string, params: SecureControllerHasSecondaryPassword$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, secureControllerHasSecondaryPassword.PATH, 'get');
  if (params) {
    rb.path('centerId', params.centerId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

secureControllerHasSecondaryPassword.PATH = '/api/secure/center/{centerId}/secondary-password/status';
